export function currentTimezone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
}

export function today(): string {
  return new Date().toISOString().slice(0, 10);
}

export type DateFormatPreference = "locale" | "iso" | "ymd_slash" | "ymd_dot" | "dmy_slash" | "dmy_dot" | "dmy_hyphen" | "mdy_slash" | "mdy_hyphen";
export function dateFormatPreference(): DateFormatPreference {
  if (typeof localStorage === "undefined") return "locale";
  const value = localStorage.getItem("dateFormat");
  if (value === "ymd") return "ymd_slash";
  if (value === "dmy") return "dmy_slash";
  return ["iso", "ymd_slash", "ymd_dot", "dmy_slash", "dmy_dot", "dmy_hyphen", "mdy_slash", "mdy_hyphen"].includes(value || "") ? value as DateFormatPreference : "locale";
}

export function dateInputOrder(): "locale" | "ymd" | "dmy" | "mdy" {
  const preference = dateFormatPreference();
  if (preference === "locale") return "locale";
  if (preference.startsWith("dmy")) return "dmy";
  if (preference.startsWith("mdy")) return "mdy";
  return "ymd";
}

export function formatDate(value: string, preference: DateFormatPreference = dateFormatPreference()): string {
  const [year, month, day] = value.slice(0, 10).split("-");
  if (preference === "iso") return `${year}-${month}-${day}`;
  if (preference === "ymd_slash") return `${year}/${month}/${day}`;
  if (preference === "ymd_dot") return `${year}.${month}.${day}`;
  if (preference === "dmy_slash") return `${day}/${month}/${year}`;
  if (preference === "dmy_dot") return `${day}.${month}.${year}`;
  if (preference === "dmy_hyphen") return `${day}-${month}-${year}`;
  if (preference === "mdy_slash") return `${month}/${day}/${year}`;
  if (preference === "mdy_hyphen") return `${month}-${day}-${year}`;
  return new Intl.DateTimeFormat(undefined, { year: "numeric", month: "short", day: "numeric" }).format(new Date(`${value.slice(0, 10)}T12:00:00`));
}

export function formatTimestamp(value: string): string {
  const instant = new Date(value);
  const local = new Date(instant.getTime() - instant.getTimezoneOffset() * 60_000).toISOString().slice(0, 10);
  const time = new Intl.DateTimeFormat(undefined, { hour: "numeric", minute: "2-digit" }).format(instant);
  return `${formatDate(local)} ${time}`;
}

export function toLocalDateTime(value?: string | null): string {
  if (!value) return "";
  const date = new Date(value);
  const local = new Date(date.getTime() - date.getTimezoneOffset() * 60_000);
  return local.toISOString().slice(0, 16);
}
